module.exports = __webpack_public_path__ + "img/Teen-Patti-Live-new.1b10303.png";